// ※サーバから返ってきている情報を使っている項目で、ページに反映されないデータもあるので注意
const imgPath = '/static/img/yearluck/y2023/'
const dirKey = 'touwa'

const info = {
  name: '斗弥',
  itemId: 6404,
  lpId: 3, //なければ0
  pkgTitle: '暮れの酉の2022年のあなたの運勢あああああああああああああああ',
  price: 999,
  memberPrice: 500,
  pkgDescription: 'パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。',
  pkgNotice: '',
}

const top = {
  thumbnail: `${imgPath}top/counselor/${dirKey}/top_thumnail.png`,
  pkgTitleImg: `${imgPath}top/counselor/${dirKey}/top_pkg_title_img.png`,
  pkgBackImg: `${imgPath}top/counselor/${dirKey}/top_bg.png`,
}

const input = {
  thumbnail: `${imgPath}input/counselor/${dirKey}/input_thumnail.png`,
  fukiImage: `${imgPath}input/counselor/${dirKey}/input_fuki.png`,
  pkgBackImg: `${imgPath}input/counselor/${dirKey}/bg_topinfo.png`,
  headInfoBgUpp: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_upper.png`,
  headInfoBgMdl: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_middle.png`,
}

const result = {
  title: 'TVで話題！斗弥が鑑定<br>◆2023年あなたの強運ポイント',
  thumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon_2.png`,
  underThumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon.png`,
  description: 'ようこそいらっしゃいました。あなたの2023年が開運し、うれしい出来事がたくさん訪れ、困難を乗り越えられますように。くわしく占っていきますね。',
  bottomFukiMessage: '鑑定はいかがでしたか？　あなたの新しい1年が素敵な年になりますように…。<br>もう少し、あなたにお伝えしたいことがあります。よろしければ、見ていってくださいね。',
}

export default {
  info,
  top,
  input,
  result,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/YearLuck/y2023/data/counselor/pkg04_touwa.js